import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldInputSelect } from "@/components/FormFields/FormFieldInputSelect/FormFieldInputSelect";
import { type FormSelectChoice, type InputSelectComponentProps } from "@/lib/types/types";

export const StateSelectComponent = ({
  value,
  isErrored,
  options,
  onChange,
  placeholder = "",
  label = "",
  isRequired = false,
  disabled = false,
}: InputSelectComponentProps) => {
  const { msg } = useMessage();

  const stateFieldId = "state";

  return (
    <FormFieldInputSelect
      fieldId={stateFieldId}
      value={options.find((option) => option.value === value)}
      refId="state"
      onChange={(state: FormSelectChoice) => onChange(state)}
      placeholder={placeholder || msg({ id: "statePlaceholder" })}
      label={label || <FormattedHTMLMessage id="state" defaultMessage="State" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidState" defaultMessage="Invalid state" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      options={options}
      isRequired={isRequired}
      buttonRef="inputSelectButtonState"
      containerId={`sid-${stateFieldId}__select`}
      disabled={disabled}
      autoComplete="address-level1"
    />
  );
};
